import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PaperworkLayout } from "../components/PaperworkLayout";
import { PaperworkHeader } from "../components/PaperworkHeader";
import { PaperworkSearchInput } from "../components/PaperworkSearchInput";
import { usePermission } from "../../../../hooks/usePermission";
import { PERMISSIONS } from "../../../../consts/api";
import { PaperworkMenu } from "../components/PaperworkMenu";
import { QuestionnairesList } from "../components/QuestionnairesList/QuestionnairesList";
import { PROVIDER_QUESTIONNAIRE_TYPE } from "../../../../api/questionnaires/useQuestionnairesQuery";
import { SETTINGS_ROUTES } from "../../../../consts/routes";

export const ProviderQuestionnaires = () => {
  const [term, setTerm] = useState("");

  const manageQuestionnaires = usePermission(
    PERMISSIONS.settings.manageQuestionnaires,
  );

  return (
    <PaperworkLayout>
      <PaperworkHeader>
        <div className="d-flex align-center gap-8">
          <PaperworkSearchInput onSearch={setTerm} />
          {manageQuestionnaires.permitted && (
            <Link
              to={SETTINGS_ROUTES.questionnaires.provider.create()}
              className="new-blue-btn edit_setting"
            >
              Create Questionnaire
            </Link>
          )}
        </div>
      </PaperworkHeader>
      <PaperworkMenu active="providerQ" />
      <div className="juvly-section full-width m-b-0">
        <div className="table-responsive">
          <table className="table-updated setting-table no-td-border no-hover">
            <thead className="table-updated-thead">
              <tr>
                <th className="col-xs-6 table-updated-th sorting">Templates</th>
                <th className="col-xs-3 table-updated-th sorting text-left">
                  Number of Questions
                </th>
                <th className="col-xs-3 table-updated-th sorting text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <QuestionnairesList
              type={PROVIDER_QUESTIONNAIRE_TYPE}
              searchTerm={term}
            />
          </table>
        </div>
      </div>
    </PaperworkLayout>
  );
};
